import { Plus, Check } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";
import { ProductImage } from "@/components/ProductImage";
import { fmt } from "@/lib/site";

export const ProductCard = ({ product }) => {
    const { addItem } = useCart();
    const [added, setAdded] = useState(false);

    const add = (e) => {
        e.preventDefault();
        e.stopPropagation();
        addItem(product, 1);
        toast.success("Agregado al carrito", { description: product.nombre });
        setAdded(true);
        setTimeout(() => setAdded(false), 1200);
    };

    return (
        <Link
            to={`/producto/${product.id}`}
            data-testid={`product-card-${product.id}`}
            className="group relative bg-hueso border border-linea rounded-2xl overflow-hidden shadow-soft hover:shadow-lift hover:-translate-y-1 transition-[transform,box-shadow] duration-300 flex flex-col"
        >
            <div className="relative aspect-square bg-white overflow-hidden">
                <ProductImage
                    src={product.foto_url}
                    alt={product.nombre}
                    className="w-full h-full object-contain p-5 transition-transform duration-500 ease-out group-hover:scale-105"
                />
                {(product.etiqueta || product.destacado) && (
                    <span className={`absolute top-3 left-3 text-white text-[10px] uppercase tracking-wider px-2 py-1 rounded-full font-bold ${product.etiqueta ? "bg-naranja" : "bg-madera"}`}>
                        {product.etiqueta || "Destacado"}
                    </span>
                )}
            </div>

            <div className="flex flex-col flex-1 p-4">
                <span className="text-[11px] uppercase tracking-wide text-mut mb-1.5 font-medium">
                    {product.marca} · {product.sku}
                </span>
                <h3 className="font-display font-semibold text-sm text-ink leading-snug line-clamp-2 flex-1">{product.nombre}</h3>
                <div className="mt-3 flex items-end justify-between gap-2">
                    <div>
                        <p className="font-display text-xl font-bold text-verde">{fmt(product.precio_usd)} <span className="text-[11px] font-sans font-semibold text-mut">+ IVA</span></p>
                        <p className="text-[11px] text-madera-dark font-medium">Mayoreo {fmt(product.precio_mayoreo)}</p>
                    </div>
                    <button
                        data-testid={`add-to-cart-${product.id}`}
                        onClick={add}
                        className={`shrink-0 h-11 w-11 rounded-full flex items-center justify-center text-white transition-colors ${added ? "bg-verde" : "bg-naranja hover:bg-naranja-dark"}`}
                        aria-label="Agregar al carrito"
                    >
                        {added ? <Check size={20} /> : <Plus size={20} strokeWidth={2.4} />}
                    </button>
                </div>
            </div>
        </Link>
    );
};
